import { isGiftCardProduct } from '@/lib/gift-card-product-utils';
import { isEventSeriesProduct } from '@/lib/event-variation';

export const WINE_VINTAGE_YEAR_ATTRIBUTE_ID = 'wineVintageYear';

type ProductWithVariationAttributes = {
    variationAttributes?: Array<{ id?: string }>;
};

/**
 * Whether a product is a wine master/variant (has the `wineVintageYear` variation attribute).
 * Wines are `c_productType: physical` in catalog — the variation attribute is the storefront signal.
 */
export function isWineProduct(product?: ProductWithVariationAttributes | null): boolean {
    return Boolean(product?.variationAttributes?.some((attribute) => attribute.id === WINE_VINTAGE_YEAR_ATTRIBUTE_ID));
}

/**
 * Products whose variant SKU is identified by attribute query params only
 * (`giftCardSize`, `wineVintageYear`, `eventInstanceId`) — do not sync `pid` into the URL.
 */
export function shouldOmitVariantPid(product?: object | null): boolean {
    return (
        isGiftCardProduct(product) ||
        isWineProduct(product as ProductWithVariationAttributes | null | undefined) ||
        isEventSeriesProduct(product as EventSeriesProduct | null | undefined)
    );
}

type EventSeriesProduct = Parameters<typeof isEventSeriesProduct>[0];
